import { genericPopup } from './util/window.functions';

export class GenericPageComponent {
  public openPrivacy() {
    genericPopup('/privacypolicy');
  }
}
